<template>
  <div class="nr">
    <!-- 問題表示欄 -->
    <div class="page-content">
      <div class="fixed flexrow">
        <div class="toparea-mic inner">
          <div class="flexcenter" v-show="showInput">
            <div class="item bgdgray bdgreen w300" :class="{ textmgray: isTextGray }">
              {{ speakText }}
              <div class="mic-icon" :class="scoreNum"></div>
            </div>
            <button class="icon-skip" @click="skipAct()" :disabled="disableSkip"></button>
          </div>
        </div><!-- /.inner -->
      </div><!-- /.page-header -->
      <!-- actブロック -->
      <div class="inner" id="js-nr-acts" :style="nrStyles">
        <transition-group name="fade" tag="div">
          <div class="flexbox" v-for="(act, index) in dispActBlockList" :key="'actKey' + index">
            <div class="thumb item" :style="getThumbPath(index, act.image)" />
              <div class="item answer">
                <div v-if="isShowCorrectImg(index) || isShowIncorrectImg(index)"
                     :class="{ correct : isShowCorrectImg(index), incorrect : isShowIncorrectImg(index) }" />
                <div class="_item">
                  <template v-if="runmode == mixinConstants.RUNMODE_NR3">
                    <!-- NR3 -->
                    <p :class="[isEnvironmentPc() ? getNRFontSize(act) : '', { active: isActActive(index) }]">
                      <span v-html="getPopupTextElem(getLangText(act))" />
                    </p>
                  </template>
                  <template v-else>
                    <!-- NR3_NT -->
                    <p v-if="showAnswerLabelNR3(index)"
                       :class="[isEnvironmentPc() ? getNRFontSize(act) : '', { active: isActActive(index) }]">
                      <span v-html="getPopupTextElem(getLangText(act))" />
                    </p>
                    <div class="q-blank" v-if="!showAnswerLabelNR3(index)">
                      <p :class="isEnvironmentPc() ? getNRFontSize(act) : ''">
                        <span v-html="getPopupTextElem(getQuestionBlankText(act))" />
                      </p>
                    </div>
                  </template>
                  <button class="icon-voice" v-on:click="audioReplay(act.sounds[0])" :disabled="disableReplayButton(index)"></button>
                </div>
              </div>
          </div>
        </transition-group>
      </div><!-- /.inner -->
    </div><!-- /.page-content -->
  </div>
</template>
<script>
import runmode from "@/mixin/runmode_nr";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

var lodash = require("lodash");

export default {
  name: "NR3",
  mixins: [
    runmode
  ],
  data() {
    return {
      // 発声英文
      speakText: "",
      // スキップ非活性フラグ
      disableSkip: true,
      // スコア
      scoreLevel: 0,
      // グレー文字
      isTextGray: true,
      // 入力エリア表示
      showInput: true,
      // 音声認識実行中
      isListenPlaying: false,
      // 音声認識タイムアウト回数
      sonicTimeoutCount: 0,
      // ACTスキップ
      isSkipAct: false,
      // 音声解析updateフラグ
      isListenForPhrasesUpdate: false,
      // ACT中止フラグ
      isStopAct: false
    };
  },
  computed: {
    mixinConstants: function() {
      return mixinConstants;
    },
    scoreNum: function() {
      return "score_" + this.scoreLevel;
    }
  },
  methods: {
    init: function() {
      const self = this;
      this.runmode = this.pathstep.mode;
      // 正解音終了処理
      this.myAudioCollect.onended = function() {
        self.audioCollectEnded();
      };
      // 初回ACT表示
      this.dispActBlockList.push(_.clone(this.currentAct));
      // 初回自動再生
      if (this.lessonState == constants.LESSON_STATE_START) {
        // STARTの場合、初回音声再生
        this.divideChallenge();
      } else {
        // 初回再生待ち
        this.waitingStart = true;
      }

      // 自動調整初期処理
      this.initAutoAdjustNR();
    },
    audioCollectEnded: function() {
      // 正解音終了処理
      const self = this;
      this.isCorrectPlaying = false;
      // 正解画像非表示
      this.showCorrectImg = false;
      // 音声認識結果初期化
      this.nextTimer = setTimeout(function() {
        // 次のACT表示処理
        self.nextAct();
      }, 1000);
    },
    audioEnded: function() {
      // 再生終了時処理
      const self = this;
      if (this.isAudioQuestionPlaing) {
        // 問題再生終了処理
        this.enableAudioReplay = true;
        // 音声認識開始
        this.listenForPhrases(this.currentAct.basicText);
      } else if (!this.isAudioReplay) {
        // リプレイではない
        if (this.isChallenge(this.currentAct) && this.sreUse === "false") {
          // 正解数更新
          this.setActState(true);
        }
        this.nextTimer = setTimeout(function() {
          self.nextAct();
        }, 1000);
      }
      // フラグ初期化
      this.isAudioQuestionPlaing = false;
      this.isAudioReplay = false;
    },
    nextAct: function() {
      // 次のACT表示
      const self = this;
      this.nextTimer = null;
      // 問題再生フラグ初期化
      this.isAudioQuestionPlaing = false;
      if (this.setNextAct(function() {
        // 音声入力エリア初期化
        this.speakText = "";
        this.isTextGray = true;
        this.scoreLevel = 0;
        this.dispActBlockList.push(_.clone(this.currentAct));
        this.$nextTick(function() {
          // ACTの表示エリアがスクロールした場合、画面下に移動
          if (typeof $("#js-nr-acts")[0] !== "undefined") {
            $("#js-nr-acts").animate({ scrollTop: $("#js-nr-acts")[0].scrollHeight }, "first", function() {
              // 回答分岐
              self.divideChallenge();
            });
          }
        });
      })) {
      } else {
        // pathstep終了
        // スキップフラグ
        this.disableSkip = true;
        this.setInterval(mixinConstants.ALLCORRECT_INTERVAL).then(function() {
          self.$emit("endAct");
        });
      }
    },
    divideChallenge: function() {
      // 回答有無振り分け
      if (this.isChallenge(this.currentAct) && this.sreUse !== "false") {
        // 回答あり
        // 問題再生フラグ
        this.isAudioQuestionPlaing = true;
        // スキップフラグ
        this.disableSkip = false;
      }
      // 音声再生
      if (this.lessonState == constants.LESSON_STATE_PAUSE) {
        // レッスン停止中
        this.stopNextAct = true;
      } else {
        this.audioPlay(this.currentAct.sounds[0]);
      }
    },
    skipAct: function() {
      // 現在のACTをスキップ
      // スキップフラグ
      this.disableSkip = true;
      this.enableAudioReplay = false;
      // 問題再生フラグ初期化
      this.isAudioQuestionPlaing = false;
      // タイマー処理中止
      clearTimeout(this.timer);
      // 音声停止
      this.myAudio.pause();
      // 音声再生中フラグ変更
      this.audioPlaying = false;
      // ACT終了
      this.finishActIndex.push(this.currentActIndex);
      if (this.isListenPlaying) {
        this.isSkipAct = true;
        // 音声解析中フラグ
        this.isListenPlaying = false;
        // 音声解析中止処理
        sonic_wrapper.interruptSession();
      } else {
        // 次のACTへ
        this.nextAct();
      }
    },
    // 音声解析実行
    listenForPhrases: function(phrases) {
      // イベントと同じ名前で実行したい関数を指定する
      // 特に処理する必要のないイベントに関しては指定しない
      var callbacks = {
        start: this.listenForPhrasesStart,
        update: this.listenForPhrasesUpdate,
        error: this.listenForPhrasesError,
        interrupting: this.listenForPhrasesInterrupting,
        success: this.listenForPhrasesSuccess,
        end: this.listenForPhrasesEnd
      };
      // 音声解析中フラグ
      this.isListenPlaying = true;
      if (this.dispAllAnswerStatus == true ||
          this.dispJapaneseStatus == true ||
          this.lessonState == constants.LESSON_STATE_PAUSE) {
        // 全解答表示中、日本語表示中、スコア・設定表示中は何もしない
        return;
      }
      // HTMLタグ除去
      phrases = phrases.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
      phrases = this.nounString(phrases);
      sonic_wrapper.listenForPhrases([phrases], callbacks);
    },
    listenForPhrasesStart() {
      // startイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesStart");
      this.isListenForPhrasesUpdate = false;
    },
    listenForPhrasesUpdate() {
      // updateイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesUpdate");
      this.isListenForPhrasesUpdate = true;
      if (sonic_wrapper.hasLfpHypothesisResponse()) {
        var response = sonic_wrapper.getLfpResponse();
        this.speakText = response;
      }
    },
    listenForPhrasesError() {
      // errorイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesError");
    },
    listenForPhrasesInterrupting() {
      // interruptingイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesInterrupting");
    },
    listenForPhrasesSuccess() {
      // successイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesSuccess");
    },
    listenForPhrasesEnd() {
      // endイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesEnd");
      const self = this;
      if (this.isStopAct) {
        // ACT中止処理
        this.$emit("stopAct");
        return;
      }
      if (sonic_wrapper.isStopReasonManual()) {
        // 音声解析中断
        if (this.isSkipAct) {
          // ACTスキップ
          this.isSkipAct = false;
          // 次のACTへ
          this.nextAct();
        }
        return;
      }
      if (!sonic_wrapper.isCalibrationResultOk()) {
        // タイムアウト
        this.sonicTimeoutCount++;
        if (this.sonicTimeoutCount >= 2) {
          // タイムアウトが2回連続発生
          this.sonicTimeoutCount = 0;
          this.$emit("showMicrophoneErrorDialog");
        } else {
          // 再挑戦
          setTimeout(function() {
            self.retryListen();
          }, 500);
        }
      } else if (!this.isListenForPhrasesUpdate) {
        // マイク未接続
        this.$emit("showMicrophoneErrorDialog");
      } else {
        this.sonicTimeoutCount = 0;
        if (!sonic_wrapper.isStopReasonManual()) {
          // 中断でない場合
          this.checkAnswer();
        }
      }
    },
    checkAnswer: function() {
      const self = this;
      // スコア
      var score = 0;
      if (sonic_wrapper.hasLfpHypothesisScore()) {
        score = sonic_wrapper.getLfpScore();
      }
      this.scoreLevel = score;
      this.showCorrectImg = false;
      this.showIncorrectImg = false;
      if (score >= mixinConstants.CORRECT_SCORE) {
        this.disableSkip = true;
        this.isTextGray = false;
        if (!_.includes(this.incorrectIndex, this.currentActIndex)) {
          this.correctIndex.push(this.currentActIndex);
          // 正解数更新
          this.setActState(true);
        }
        // 再生ボタン非活性
        this.enableAudioReplay = false;
        // 終了ACTインデックス追加
        this.finishActIndex.push(this.currentActIndex);
        // 正解画像表示
        this.showCorrectImg = true;
        // 音声解析フラグ
        this.isListenPlaying = false;
        // 正解音
        this.isCorrectPlaying = true;
        this.audioAnswerCollect();
        // 発声英文表示欄に文言表示
        var text = this.currentAct.basicText.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
        this.speakText = text;
      } else {
        if (!_.includes(this.incorrectIndex, this.currentActIndex)) {
          this.incorrectIndex.push(this.currentActIndex);
          // 不正解数更新
          this.setActState(false);
        }
        // 不正解画像表示
        this.showIncorrectImg = true;
        clearTimeout(this.inncorectTimer);
        this.inncorectTimer = setTimeout(function() {
          // 再挑戦
          self.retryListen();
        }, this.incorrectImageDuration);
        // 不正解
        this.audioAnswerIncorrect();
      }
    },
    retryListen: function() {
      // 音声解析再挑戦
      this.showIncorrectImg = false;
      this.speakText = "";
      this.scoreLevel = 0;
      this.listenForPhrases(this.currentAct.basicText);
    },
    changeunDisp: function() {
      // 全解答、翻訳非表示
      this.showInput = true;
      if (this.isListenPlaying && this.isChallenge(this.currentAct)) {
        // 音声解析中
        // 音声解析開始
        this.listenForPhrases(this.currentAct.basicText);
      }
    },
    changeDisp: function() {
      // 全解答、翻訳表示
      this.showInput = false;
      this.sonicInterruptSession();
    },
    sonicInterruptSession: function() {
      // 音声解析中止
      if (this.isListenPlaying) {
        // 音声解析中
        // 音声解析中止処理
        sonic_wrapper.interruptSession();
      }
    }
  },
  watch: {
    dispJapaneseStatus: function(newstatus) {
      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.applyCardAreaSize();
          this.changeunDisp();
        }
      } else {
        this.applyCardAreaSize();
        this.changeDisp();
      }
    },
    dispAllAnswerStatus: function(newstatus) {
      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.applyCardAreaSize();
          this.changeunDisp();
        }
      } else {
        this.applyCardAreaSize();
        this.changeDisp();
      }
    },
    lessonState: function(state) {
      // ステータス処理
      if (this.waitingStart && state == constants.LESSON_STATE_START) {
        // STARTの場合、初回音声再生
        this.waitingStart = false;
        this.divideChallenge();
      } else if (state == constants.LESSON_STATE_STOP) {
        // レッスン停止の場合
        this.destroyRunmode();
        if (sonic_wrapper.isSessionRunning()) {
          // 音声解析停止
          this.isStopAct = true;
          sonic_wrapper.interruptSession();
        } else {
          // ACT停止
          this.$emit("stopAct");
        }
      } else if (state == constants.LESSON_STATE_PAUSE) {
        // レッスン停止
        if (!this.myAudio.ended && this.myAudio.paused) {
          // 音声停止中の場合
          this.audioPlaying = true;
        }
        // 再挑戦
        if (this.inncorectTimer) {
          clearTimeout(this.inncorectTimer);
        }
        // 次のACT
        if (this.nextTimer) {
          clearTimeout(this.nextTimer);
        }
        this.sonicInterruptSession();
      } else if (state == constants.LESSON_STATE_RESTART) {
        // レッスンリスタート
        if (this.nextTimer) {
          this.nextAct();
        } else if (this.stopNextAct) {
          // 次ACT停止中
          this.stopNextAct = false;
          this.divideChallenge();
        } else if (this.isListenPlaying) {
          // 音声解析中
          // 音声解析開始
          this.retryListen();
          this.audioPlaying = false;
        } else if (this.isAudioReplay) {
          // リプレイ中
          this.audioPlaying = false;
          this.isAudioReplay = false;
        } else if (this.isCorrectPlaying) {
          // 正解音再生
          this.audioCollectEnded();
        } else if (!this.myAudio.ended && this.myAudio.paused) {
          // 音声未終了で音声停止中
          if (this.myAudio.paused) {
            this.audioPlaying = true;
            this.myAudio.currentTime = 0;
            this.myAudio.play();
          }
        }
      }
      // 自動調整表示処理
      this.autoAdjustFirstShownNR();
    }
  },
  mounted() {
    this.init();
  },
  beforeDestroy: function() {
    // 音声解析中止処理
    sonic_wrapper.interruptSession();
  }
};
</script>
<style lang="scss" scoped>
@import "src/assets/style/card";
@import "src/assets/style/nr";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// NR3.vue?ac015996